export const trainingParameters = {
  batchSize: 32,
  patience: 20,
  epochs: 100,
  validation: 20,
  newValidationSplit: false,
};

export const trainingModels = {
  yolov5: {
    variant: {
      nu: {
        batchSizeLimit: null,
      },
      su: {
        batchSizeLimit: null,
      },
      mu: {
        batchSizeLimit: null,
      },
      lu: {
        batchSizeLimit: null,
      },
      xu: {
        batchSizeLimit: null,
      },
    },
  },
  yolov8: {
    variant: {
      n: {
        batchSizeLimit: 155,
      },
      s: {
        batchSizeLimit: 85,
      },
      m: {
        batchSizeLimit: 50,
      },
      l: {
        batchSizeLimit: 30,
      },
      x: {
        batchSizeLimit: 24,
      },
    },
  },
};
